module.exports = __webpack_public_path__ + "static/media/features_accaunts.38cb8e03.svg";